import { REFERRAL_CODE_PATTERN } from '@devizy/shared';
import { Link, createFileRoute } from '@tanstack/react-router';
import * as React from 'react';

import { SignUpForm } from '@/components/auth/sign-up-form';
import { rememberPendingReferralCode } from '@/lib/auth/pending-referral';

const INVITE_REGEX = /^[A-Za-z0-9_-]{16,128}$/;

export const Route = createFileRoute('/_auth/sign-up')({
  validateSearch: (search: Record<string, unknown>): { ref?: string; invite?: string } => {
    const result: { ref?: string; invite?: string } = {};
    if (typeof search.ref === 'string' && REFERRAL_CODE_PATTERN.test(search.ref)) {
      result.ref = search.ref;
    }
    if (typeof search.invite === 'string' && INVITE_REGEX.test(search.invite)) {
      result.invite = search.invite;
    }
    return result;
  },
  component: SignUpPage,
});

function SignUpPage(): React.ReactElement {
  const { ref, invite } = Route.useSearch();
  React.useEffect(() => {
    rememberPendingReferralCode(ref);
  }, [ref]);
  return (
    <section className="border-border bg-card shadow-diffusion rounded-2xl border p-8">
      <h1 className="font-display text-2xl tracking-tight">Créer un compte</h1>
      <p className="text-muted-foreground mt-2 text-sm">
        Choisissez votre rôle et votre devise — la devise est figée pour la vie du compte.
      </p>
      <div className="mt-8">
        <SignUpForm refCode={ref} inviteToken={invite} />
      </div>
      <p className="text-muted-foreground mt-6 text-center text-sm">
        Déjà inscrit ?{' '}
        <Link to="/sign-in" className="text-primary font-medium hover:underline">
          Se connecter
        </Link>
      </p>
    </section>
  );
}
